<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header">
      <div class="px-3 col-3 p-0">
        <div class="heading">{{ $t('result.round') }}</div>
        <div class="text-subhead">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead">{{ data.count === 0
          ? data.bet
          : data.detail.summary[data.count].bet.amount | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead"> {{ winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead">{{ balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result pt-3">
      <div class="text-game">{{ 'GHOST HOUSE' }}</div>
      <div class="text-subgame">{{ $t('ghost.name') }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side" @click="delCount()"></i>
        </div>
        <div class="all-table container d-flex flex-column justify-content-center">
          <table>
            <tbody>
              <tr v-for="(row, index) in table" :key="index">
                <td v-for="(col, i) in row" :key="`${index}${i}`">
                  <img class="icon-symbol" :src="require(`../../assets/resultGame/ghost/symbol_${col}.png`)" alt="">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side" @click="addCount()"></i>
        </div>
      </div>
      <div v-if="isFreespin" class="text-subgame mb-1">{{ $t('result.freespin') + ' ' + result.freeSpinsPlayed +
        '/' + result.freeSpinsCount }}</div>
      <div v-if="isFreespin" class="text-game">{{ $t('result.multiplier') + ' ' + 'x' +
        result.freeSpinsCurrentMultiplier }}</div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>

      <div v-if="result.featureBuy" class="text-feature-gh" style="font-">Feature Buy</div>

      <div class="col-12 justify-content-center d-flex flex-row mt-4">
        <div class="bet-box p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in result.winCombos" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper item">
                <div class="d-flex justify-content-start bet-wrapper item">
                  <img class="icon-detail-gh" :src="require(`../../assets/resultGame/ghost/symbol_${detail[0]}.png`)"
                    alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1 green">{{ `${detail[1]} ` + $t('result.kind') }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ (isFreespin
                      ? (result.freeSpinsCurrentMultiplier === 0
                        ? (result.winnings[index] * 1)
                        : (result.winnings[index] * result.freeSpinsCurrentMultiplier))
                      : (result.winnings[index])
                    ) | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bet-warpper item" v-if="result.winShowsCount === 0">
            <div class="d-flex justify-content-between mt-5">
              <div class="bet-wrapper item align-content-center d-flex">
                <div class="d-flex justify-content-center bet-wrapper item align-content-center p-3">
                  <p class="my-1 red">{{ 'No Winnings' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-ghost',
  props: {
    data: Object,
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 4, 7, 10, 13,],
        [2, 5, 8, 11, 14,],
        [3, 6, 9, 12, 15,],
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      result: this.data,
      count: this.data.count,
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
    }
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header')[0].offsetHeight
    },
    mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.result = result;
      this.isEndRound = result.isEndRound;
      this.winnings = result.winnings;
      this.freeSpinsCurrentMultiplier = result.freeSpinsCurrentMultiplier;
      this.isFreespin =
        result.state === "FREESPIN" ||
        result.state === "FREERESPIN";
      this.isRespin = result.state === "RESPIN";
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      if (this.isFreespin) {
        const reel1 = this.data.game.config.freeGameReel1
        const reel2 = this.data.game.config.freeGameReel2
        const reel3 = this.data.game.config.freeGameReel3
        const reel4 = this.data.game.config.freeGameReel4
        const reel5 = this.data.game.config.freeGameReel5

        const indexReel1 = this.result.freeReelStopIndexes[0]
        const indexReel2 = this.result.freeReelStopIndexes[1]
        const indexReel3 = this.result.freeReelStopIndexes[2]
        const indexReel4 = this.result.freeReelStopIndexes[3]
        const indexReel5 = this.result.freeReelStopIndexes[4]

        this.table[0][0] = reel1[indexReel1]
        this.table[1][0] = reel1[indexReel1 + 1] === undefined ? reel1[0] : reel1[indexReel1 + 1]
        this.table[2][0] = reel1[indexReel1 + 2] === undefined ? indexReel1 + 2 === reel1.length ? reel1[0] : reel1[1] : reel1[indexReel1 + 2]
        this.table[0][1] = reel2[indexReel2]
        this.table[1][1] = reel2[indexReel2 + 1] === undefined ? reel2[0] : reel2[indexReel2 + 1]
        this.table[2][1] = reel2[indexReel2 + 2] === undefined ? indexReel2 + 2 === reel2.length ? reel2[0] : reel1[1] : reel2[indexReel2 + 2]
        this.table[0][2] = reel3[indexReel3]
        this.table[1][2] = reel3[indexReel3 + 1] === undefined ? reel3[0] : reel3[indexReel3 + 1]
        this.table[2][2] = reel3[indexReel3 + 2] === undefined ? indexReel3 + 2 === reel3.length ? reel3[0] : reel3[1] : reel3[indexReel3 + 2]
        this.table[0][3] = reel4[indexReel4]
        this.table[1][3] = reel4[indexReel4 + 1] === undefined ? reel4[0] : reel4[indexReel4 + 1]
        this.table[2][3] = reel4[indexReel4 + 2] === undefined ? indexReel4 + 2 === reel4.length ? reel4[0] : reel4[1] : reel4[indexReel4 + 2]
        this.table[0][4] = reel5[indexReel5]
        this.table[1][4] = reel5[indexReel5 + 1] === undefined ? reel5[0] : reel5[indexReel5 + 1]
        this.table[2][4] = reel5[indexReel5 + 2] === undefined ? indexReel5 + 2 === reel5.length ? reel5[0] : reel5[1] : reel5[indexReel5 + 2]
      } else {
        const reel1 = this.data.game.config.baseGameReel1
        const reel2 = this.data.game.config.baseGameReel2
        const reel3 = this.data.game.config.baseGameReel3
        const reel4 = this.data.game.config.baseGameReel4
        const reel5 = this.data.game.config.baseGameReel5

        const indexReel1 = this.result.baseReelStopIndexes[0]
        const indexReel2 = this.result.baseReelStopIndexes[1]
        const indexReel3 = this.result.baseReelStopIndexes[2]
        const indexReel4 = this.result.baseReelStopIndexes[3]
        const indexReel5 = this.result.baseReelStopIndexes[4]

        this.table[0][0] = reel1[indexReel1]
        this.table[1][0] = reel1[indexReel1 + 1] === undefined ? reel1[0] : reel1[indexReel1 + 1]
        this.table[2][0] = reel1[indexReel1 + 2] === undefined ? indexReel1 + 2 === reel1.length ? reel1[0] : reel1[1] : reel1[indexReel1 + 2]
        this.table[0][1] = reel2[indexReel2]
        this.table[1][1] = reel2[indexReel2 + 1] === undefined ? reel2[0] : reel2[indexReel2 + 1]
        this.table[2][1] = reel2[indexReel2 + 2] === undefined ? indexReel2 + 2 === reel2.length ? reel2[0] : reel1[1] : reel2[indexReel2 + 2]
        this.table[0][2] = reel3[indexReel3]
        this.table[1][2] = reel3[indexReel3 + 1] === undefined ? reel3[0] : reel3[indexReel3 + 1]
        this.table[2][2] = reel3[indexReel3 + 2] === undefined ? indexReel3 + 2 === reel3.length ? reel3[0] : reel3[1] : reel3[indexReel3 + 2]
        this.table[0][3] = reel4[indexReel4]
        this.table[1][3] = reel4[indexReel4 + 1] === undefined ? reel4[0] : reel4[indexReel4 + 1]
        this.table[2][3] = reel4[indexReel4 + 2] === undefined ? indexReel4 + 2 === reel4.length ? reel4[0] : reel4[1] : reel4[indexReel4 + 2]
        this.table[0][4] = reel5[indexReel5]
        this.table[1][4] = reel5[indexReel5 + 1] === undefined ? reel5[0] : reel5[indexReel5 + 1]
        this.table[2][4] = reel5[indexReel5 + 2] === undefined ? indexReel5 + 2 === reel5.length ? reel5[0] : reel5[1] : reel5[indexReel5 + 2]
      }

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  }
}
</script>

<style scoped>
.icon-detail-gh {
  width: 100px;
  height: 80px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side {
  color: #cac095;
  text-align: center;
  font-size: 90px;
}

.bet-box {
  background: #0c161f;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper .item {
  color: #fff;
  background: #06112d;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #cac095;
}

.bet-box .bet-wrapper:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper,
.result-wrapper {
  font-size: 35px;
}

.header {
  background: #0d1b28;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading {
  color: #72c38c;
  text-align: center;
}

.content-result {
  background: #292933;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-game {
  color: #72c38c;
  font-size: 25px;
  text-align: center;
}

.text-subhead {
  font-size: px;
  color: white;
  text-align: center;
}

.text-subgame {
  font-size: 20px;
  color: white;
  text-align: center;
}

.text-feature-gh {
  font-size: 30px;
  color: white;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #c7b873;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol {
  width: 100%;
}

.bet-box {
  min-width: 600px;
  max-width: auto;
}

.all-table {
  background: url('~@/assets/resultGame/ghost/Ghost-house_Frame.png') no-repeat;
  background-size: 770px 440px;
  width: 770px;
  height: 440px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .all-table {
    background-size: 700px 400px;
    width: 700px;
    height: 380px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side {
    font-size: 60px;
  }

  .bet-box {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading {
    font-size: 18px;
  }

  .all-table {
    background-size: 540px 350px;
    width: 550px;
    height: 350;
    margin-bottom: 1%;
    padding-bottom: 35px;
  }

  .text-subhead {
    font-size: 18px;
  }

  .arrow-side {
    font-size: 50px;
  }

  .bet-box {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {
  .header>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading {
    font-size: 12px;
  }

  .all-table {
    background-size: 305px 180px;
    width: 305px;
    height: 180px;
    padding-top: 1.5rem;
  }

  .text-subhead {
    font-size: 14px;
  }

  .bet-box {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bet-wrapper,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-gh {
    width: 50px;
    height: 40px;
  }
}
</style>